import {Injectable} from '@angular/core';
import {environment} from '../../../environments/environment';
import {HttpRequestService} from '../../shared/services/http-request.service';

@Injectable()
export class PushMessageDetailsService {

  private getPushMessageNewURL = environment.apiUrl + '/PushMessageCms/NewPushMessage';
  private getVenuesUrl = environment.apiUrl + '/VenueCms/GetVenuesForPushMessage';
  private getEventsUrl = environment.apiUrl + '/EventCms/GetEventsForPushMessage';



  constructor(private _http: HttpRequestService) {
  }



  new(request) {
    return this._http.post(this.getPushMessageNewURL, request);
  }

  getVenues(type) {
    return this._http.get(this.getVenuesUrl+"?type="+type);
  }

  getEvents() {
    return this._http.get(this.getEventsUrl);
  }
}




// WEBPACK FOOTER //
// C:/NightKey/CMS/nightkey-cms/src/app/push-messages/push-message-details/push-message-details.service.ts